// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-article-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 1000;
}

.add-article-container {
  min-width: 436px;
  background: linear-gradient(180deg, #0f172a, #020617);
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
  color: #fff;
  position: relative;
}

.add-article-container h2 {
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 600;
}

.add-article-container form {
  display: flex;
  flex-direction: column;
}

/* 🔥 Inputs (bright text) */
.add-article-container input,
.add-article-container select,
.add-article-container textarea {
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  background: #020617;
  color: #f8fafc;
  font-weight: 500;
  letter-spacing: 0.3px;
  outline: none;
}

/* Placeholder */
.add-article-container input::placeholder,
.searchable-dropdown input::placeholder {
  color: #64748b;
}

/* Focus glow */
.add-article-container input:focus,
.add-article-container select:focus,
.add-article-container textarea:focus,
.searchable-dropdown input:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
  color: #ffffff;
  text-shadow: 0 0 6px rgba(250, 204, 21, 0.3);
  caret-color: #facc15;
}

/* Button */
.add-article-container button {
  background: #facc15;
  color: #020617;
  font-weight: 600;
  padding: 12px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
}

.add-article-container button:hover {
  background: #fde047;
}

/* Close button */
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 22px;
  cursor: pointer;
}

.close-btn:hover {
  color: #facc15;
  transform: rotate(90deg);
}

/* 🔍 Searchable dropdown */
.searchable-dropdown {
  position: relative;
}

.searchable-dropdown input {
  width: 100%;
}

/* Dropdown list */
.dropdown-list {
  position: absolute;
  width: 100%;
  background: #020617;
  border: 1px solid #1e293b;
  border-radius: 12px;
  margin-top: 6px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

/* Items */
.dropdown-item {
  padding: 12px;
  color: #e2e8f0;
  cursor: pointer;
}

.dropdown-item:hover {
  background: #1e293b;
  color: #facc15;
}

/* Scrollbar */
.dropdown-list::-webkit-scrollbar {
  width: 6px;
}

.dropdown-list::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 10px;
}

/* Selection highlight */
::selection {
  background: #facc15;
  color: #020617;
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Article Master/AddArticle/AddArticle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;;;EAGE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA,gBAAgB;AAChB;;EAEE,cAAc;AAChB;;AAEA,eAAe;AACf;;;;EAIE,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".add-article-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  z-index: 1000;\n}\n\n.add-article-container {\n  min-width: 436px;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  padding: 30px;\n  border-radius: 20px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);\n  color: #fff;\n  position: relative;\n}\n\n.add-article-container h2 {\n  margin-bottom: 20px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.add-article-container form {\n  display: flex;\n  flex-direction: column;\n}\n\n/* 🔥 Inputs (bright text) */\n.add-article-container input,\n.add-article-container select,\n.add-article-container textarea {\n  margin-bottom: 16px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  background: #020617;\n  color: #f8fafc;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n  outline: none;\n}\n\n/* Placeholder */\n.add-article-container input::placeholder,\n.searchable-dropdown input::placeholder {\n  color: #64748b;\n}\n\n/* Focus glow */\n.add-article-container input:focus,\n.add-article-container select:focus,\n.add-article-container textarea:focus,\n.searchable-dropdown input:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n  color: #ffffff;\n  text-shadow: 0 0 6px rgba(250, 204, 21, 0.3);\n  caret-color: #facc15;\n}\n\n/* Button */\n.add-article-container button {\n  background: #facc15;\n  color: #020617;\n  font-weight: 600;\n  padding: 12px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n}\n\n.add-article-container button:hover {\n  background: #fde047;\n}\n\n/* Close button */\n.close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.close-btn:hover {\n  color: #facc15;\n  transform: rotate(90deg);\n}\n\n/* 🔍 Searchable dropdown */\n.searchable-dropdown {\n  position: relative;\n}\n\n.searchable-dropdown input {\n  width: 100%;\n}\n\n/* Dropdown list */\n.dropdown-list {\n  position: absolute;\n  width: 100%;\n  background: #020617;\n  border: 1px solid #1e293b;\n  border-radius: 12px;\n  margin-top: 6px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n/* Items */\n.dropdown-item {\n  padding: 12px;\n  color: #e2e8f0;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background: #1e293b;\n  color: #facc15;\n}\n\n/* Scrollbar */\n.dropdown-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdown-list::-webkit-scrollbar-thumb {\n  background: #334155;\n  border-radius: 10px;\n}\n\n/* Selection highlight */\n::selection {\n  background: #facc15;\n  color: #020617;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
